import * as mutation from "./mutation-types";
import * as action from "./action-types";
import * as systemLogMutation from "@/store/system-logs/mutation-types";
import * as lcMutation from "@/store/levy-collections/mutation-types";
import * as lcpMutation from "@/store/levy-collection-providers/mutation-types";
import * as providerMutation from "@/store/providers/mutation-types";
import * as pcMutation from "@/store/provider-contacts/mutation-types";
import * as levyEstimatorMutation from "@/store/levy-estimator/mutation-types";
import * as invoiceMutation from "@/store/invoices/mutation-types";
import * as noticeMutation from "@/store/notices/mutation-types";
import * as dashboardMutation from "@/store/dashboard/mutation-types";
import { deepCopyAxiosException } from "@/store/helpers";
import { SHOW_NOTIFICATION } from "@/store/notifications/mutation-types";
import { GLOBAL_ERROR } from "@/store/system/mutation-types";
import { tableHelper } from "@/helpers/table.helper";
import axios from "axios";

export const actions = {
  async [action.LIST]({ commit, state }) {
    commit(mutation.LIST_STARTED);
    try {
      const url = tableHelper.constructUrl("/api/scheduled-jobs", state.listing.paging);
      const { headers, data } = await axios.get(url);
      commit(mutation.LIST_SET_CRITERIA_DESCRIPTION, tableHelper.getCriteriaInfo(headers));
      commit(mutation.LIST_SET_PAGING, tableHelper.getPagingFromHeaders(headers));
      commit(mutation.LIST_SUCCEEDED, data);
      return true;
    } catch (e) {
      commit(mutation.LIST_FAILED);
      commit(GLOBAL_ERROR, deepCopyAxiosException(e));
      return false;
    }
  },
  async [action.LIST_NEXT_PAGE]({ state, commit, dispatch }) {
    commit(mutation.LIST_SET_PAGING, { page: state.listing.paging.page + 1 });
    await dispatch(action.LIST);
  },
  async [action.LIST_PREVIOUS_PAGE]({ state, commit, dispatch }) {
    commit(mutation.LIST_SET_PAGING, { page: state.listing.paging.page - 1 });
    await dispatch(action.LIST);
  },

  async [action.VIEW]({ commit, state }, id) {
    commit(mutation.VIEW_STARTED, id);
    try {
      const url = `/api/scheduled-jobs/${id}`;
      const { data } = await axios.get(url);
      commit(mutation.VIEW_SUCCEEDED, data);
      const index = tableHelper.getIndexOfId(state.listing, state.view.data.id);
      commit(mutation.VIEW_NEXT, tableHelper.getNextRecordInfo(index, state.listing));
      commit(mutation.VIEW_PREVIOUS, tableHelper.getPreviousRecordInfo(index, state.listing));
      return true;
    } catch (e) {
      commit(mutation.VIEW_FAILED);
      commit(GLOBAL_ERROR, deepCopyAxiosException(e));
      return false;
    }
  },
  async [action.VIEW_REFRESH]({ state, dispatch }, scheduledJobId) {
    if (!state.view.loading) {
      await dispatch(action.VIEW, scheduledJobId);
    }
  },

  async [action.EDIT_GET]({ commit }, id) {
    commit(mutation.EDIT_GET_STARTED);
    try {
      const url = `/api/scheduled-jobs/${id}`;
      const { data } = await axios.get(url);
      commit(mutation.EDIT_GET_SUCCEEDED, data);
      return true;
    } catch (e) {
      commit(mutation.EDIT_GET_FAILED);
      commit(GLOBAL_ERROR, deepCopyAxiosException(e));
      return false;
    }
  },
  async [action.EDIT_SAVE]({ commit, state }) {
    commit(mutation.EDIT_SAVE_STARTED);
    try {
      let result;
      const id = state.edit.data.id;
      if (state.edit.isNew) {
        result = await axios.post("/api/scheduled-jobs", state.edit.data);
      } else {
        result = await axios.put(`/api/scheduled-jobs/${id}`, state.edit.data);
      }
      commit(mutation.EDIT_SAVE_SUCCEEDED, result.data);
      commit(mutation.STATE_UNLOAD);
      commit(systemLogMutation.STATE_UNLOAD);
      commit(SHOW_NOTIFICATION, `Scheduled job ${state.edit.isNew ? "created" : "updated"}.`);
      return true;
    } catch (e) {
      commit(mutation.EDIT_SAVE_FAILED, deepCopyAxiosException(e));
      return false;
    }
  },
  async [action.EDIT_DELETE]({ commit }, id) {
    commit(mutation.EDIT_DELETE_STARTED, id);
    try {
      await axios.delete(`/api/scheduled-jobs/${id}`);
      commit(mutation.STATE_UNLOAD, true);
      commit(systemLogMutation.STATE_UNLOAD);
      commit(mutation.EDIT_DELETE_SUCCEEDED);
      commit(SHOW_NOTIFICATION, "Scheduled job deleted.");
      return true;
    } catch (e) {
      commit(mutation.EDIT_DELETE_FAILED);
      commit(GLOBAL_ERROR, deepCopyAxiosException(e));
      return false;
    }
  },

  async [action.RUN]({ commit }, id) {
    commit(mutation.RUN_STARTED, id);
    try {
      await axios.post(`/api/scheduled-jobs/${id}/run`);
      commit(mutation.RUN_SUCCEEDED);
      commit(mutation.STATE_UNLOAD);
      commit(systemLogMutation.STATE_UNLOAD);
      commit(dashboardMutation.STATE_UNLOAD);
      commit(lcMutation.STATE_UNLOAD);
      commit(lcpMutation.STATE_UNLOAD);
      commit(levyEstimatorMutation.STATE_UNLOAD);
      commit(noticeMutation.STATE_UNLOAD);
      commit(invoiceMutation.STATE_UNLOAD);
      commit(providerMutation.STATE_UNLOAD);
      commit(pcMutation.STATE_UNLOAD);
      commit(SHOW_NOTIFICATION, "Scheduled job was run.");
      return true;
    } catch (e) {
      commit(mutation.RUN_FAILED);
      commit(GLOBAL_ERROR, deepCopyAxiosException(e));
      return false;
    }
  },
  async [action.RUN_OVERDUE]({ commit }) {
    commit(mutation.RUN_OVERDUE_STARTED);
    try {
      await axios.post(`/api/scheduled-jobs/run`);
      commit(mutation.RUN_OVERDUE_SUCCEEDED);
      commit(mutation.STATE_UNLOAD);
      commit(systemLogMutation.STATE_UNLOAD);
      commit(dashboardMutation.STATE_UNLOAD);
      commit(lcMutation.STATE_UNLOAD);
      commit(lcpMutation.STATE_UNLOAD);
      commit(levyEstimatorMutation.STATE_UNLOAD);
      commit(noticeMutation.STATE_UNLOAD);
      commit(invoiceMutation.STATE_UNLOAD);
      commit(providerMutation.STATE_UNLOAD);
      commit(SHOW_NOTIFICATION, "Overdue scheduled jobs were run.");
      return true;
    } catch (e) {
      commit(mutation.RUN_OVERDUE_FAILED);
      commit(GLOBAL_ERROR, deepCopyAxiosException(e));
      return false;
    }
  }
};
